// extracted by mini-css-extract-plugin
export default {"raw-hprim":"_raw-hprim_i9UMTT","upload-label":"_upload-label_vAQIGh"};